// @flow
import _ from 'lodash';
import * as Reselect from "reselect";
import UserAvatar from '../../../assets/images/UserAvatar.png';
import { getSquadSizeArray } from '../../../helpers/league';
import getLeague from '../league/getLeague';

const AVATAR_PATH = process.env.REACT_APP_AVATARS_PATH || '';

type PropsAvatar = {
	user_id: number,
	avatar_version: number
};

export const getPreDraftList = (state: Object) => _.get(state, 'teamsDraft.pre_draft_list', []);

export const getShowTeam = (state: Object) => _.get(state, 'teamsDraft.user_team', []);

export const isPDLReceived = (state: Object) => (
	_.get(state, 'teamsDraft.is_pre_draft_list_received', false)
);

export const getAvatar = ({ user_id, avatar_version }: PropsAvatar) => {
	return user_id ? `${AVATAR_PATH}${user_id}.png?v=${avatar_version}` : UserAvatar;
};

export const getSelectedTeamWithEmptyPos = Reselect.createSelector(
	(state, props) => getShowTeam(state),
	getLeague,
	(selected_team, league) => {
		const squad_size_array = getSquadSizeArray(league);

		const { lineup } = selected_team;
		const lineup_pure = _.chain(lineup)
			.omit( ['captain', 'vice_captain', 'emergency'])
			.reduce((new_lineup, line, key) => {
				const is_key_num = parseInt(key, 10);
				const max = is_key_num ? squad_size_array[key - 1] : _.last(squad_size_array);
				const min = _.size(line);
				return {
					...new_lineup,
					[key]: _.concat(line, _.range(0, max - min, 0))
				};
			}, {})
			.value();
		return {
			...selected_team,
			lineup: {
				...lineup,
				...lineup_pure
			}
		};
	}
);


// WEBPACK FOOTER //
// ./src/modules/selectors/team/index.js